import { Link, Outlet } from 'react-router-dom'
import Sidebar from './Sidebar'
import Footer from '../common/Footer'
import { FooterLinks } from '@/data'
import { Facebook, Instagram } from 'lucide-react'
import { ASSETS } from '@/config'
import {
  BUSINESS_MAIN_PAGE,
  BUSINESS_SOCIALS_FACEBOOK,
  BUSINESS_SOCIALS_INSTAGRAM,
  LOYALTY_PROGRAMME_NAME,
  LOYALTY_PROGRAMME_TAG_LINE,
  LOYALTY_PROGRAMME_TAG_LINE_DESCRIPTION,
} from '@/Constants'
import { cn } from '@/lib/utils'


export default function PortalLayout() {
  return (
    <div className="flex min-h-screen bg-background">
      <Sidebar />
      {/* 
        // * Below <div className="md:w-20" /> is used as a placeholder to position the side nav bar correctly.
      */}
      <div className="md:w-20" />
      <div className="flex-1 overflow-y-auto">
        <main className='portal-main-bg'>
          <Outlet />
        </main>
        <div className='bg-primary'>
          <Footer
            customFooter={
              <div className="text-secondary px-12 py-6">
                <div className="h-full w-full flex flex-col justify-center items-center gap-6 py-6">
                  <div className={cn(
                    "h-full w-full flex flex-col items-center lg:flex-row justify-center gap-6",
                    LOYALTY_PROGRAMME_TAG_LINE_DESCRIPTION ? "lg:gap-6 xl:gap-64" : "lg:gap-64"
                  )}
                  >
                    <div
                      className="w-[12rem] h-[12rem] rounded-full bg-secondary flex flex-col justify-center items-center p-6 overflow-hidden"
                    >
                      {BUSINESS_MAIN_PAGE ?
                        <a
                          href={BUSINESS_MAIN_PAGE}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="h-full w-full flex justify-center items-center"
                        >
                          <img
                            className="hover:scale-105 transition-transform duration-300 object-contain w-full h-full"
                            src={ASSETS.CUSTOMER_LOGO}
                            alt="Organization Footer Logo"
                          />
                        </a>
                        :
                        <img
                          className="object-contain w-full h-full"
                          src={ASSETS.CUSTOMER_LOGO}
                          alt="Organization Footer Logo"
                        />
                      }
                    </div>
                    <div className="text-2xl lg:text-5xl">
                      {LOYALTY_PROGRAMME_NAME}
                      {LOYALTY_PROGRAMME_TAG_LINE &&
                        <div className='text-sm lg:text-xl pt-3 opacity-75'>
                          <i>"{LOYALTY_PROGRAMME_TAG_LINE}"</i>
                        </div>
                      }
                      {LOYALTY_PROGRAMME_TAG_LINE_DESCRIPTION &&
                        <p className="pt-6 text-center lg:text-left text-lg max-w-2xl mx-auto opacity-90">
                          {LOYALTY_PROGRAMME_TAG_LINE_DESCRIPTION}
                        </p>
                      }
                    </div>
                  </div>
                </div>
                <div className="border-t border-primary-foreground/20 pt-6">
                  <div className="flex flex-col gap-6 md:flex-row md:gap-0 justify-between items-center space-y-4 md:space-y-0">
                    <div className="flex flex-col md:flex-row items-center gap-3 text-xs">
                      {FooterLinks.map(fL =>
                        <Link
                          key={fL.id}
                          className='hover:text-secondary/80'
                          to={fL.to}
                          rel="noopener noreferrer"
                          target="_blank"
                        >
                          {fL.name}
                        </Link>
                      )}
                    </div>
                    {(BUSINESS_SOCIALS_FACEBOOK || BUSINESS_SOCIALS_INSTAGRAM) &&
                      <div className="flex space-x-4">
                        {BUSINESS_SOCIALS_INSTAGRAM &&
                          <a
                            href={BUSINESS_SOCIALS_INSTAGRAM}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="hover:text-secondary/80"
                          >
                            <Instagram className="w-5 h-5" />
                          </a>
                        }
                        {BUSINESS_SOCIALS_FACEBOOK &&
                          <a
                            href={BUSINESS_SOCIALS_FACEBOOK}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="hover:text-secondary/80"
                          >
                            <Facebook className="w-5 h-5" />
                          </a>
                        }
                      </div>
                    }
                  </div>
                  <div className="text-center mt-8 text-sm opacity-75">
                    <p>
                      Powered by ShoutOUT (
                      <a
                        href="https://cxforge.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hover:text-secondary/80 transition-opacity underline"
                      >
                        CXForge
                      </a>
                      )
                    </p>
                  </div>
                </div>
              </div>
            }
          />
        </div>
      </div>
    </div>
  )
} 